var map = {
	"./cs.json": 77,
	"./de.json": 78,
	"./en.json": 79,
	"./hu.json": 80,
	"./pl.json": 81,
	"./pt.json": 82,
	"./sk.json": 83,
	"./sv.json": 84
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;


//////////////////
// WEBPACK FOOTER
// ./lang ^\.\/.*\.json$
// module id = 30
// module chunks = d-game